import { render, staticRenderFns } from "./AuthCheck.vue?vue&type=template&id=400b0085&scoped=true"
import script from "./AuthCheck.vue?vue&type=script&lang=js"
export * from "./AuthCheck.vue?vue&type=script&lang=js"
import style0 from "./AuthCheck.vue?vue&type=style&index=0&id=400b0085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b0085",
  null
  
)

export default component.exports